var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_ig") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "var6_video",
    transform: "translate(-460.000000, -181.000000)",
    fill: "#7F7F7F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ig",
    transform: "translate(460.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0219727,22 L5.9780273,22 C2.6816406,22 0,19.3183594 0,16.0219727 L0,5.9780273 C0,2.6816406 2.6816406,0 5.9780273,0 L16.0219726,0 C19.3183594,0 22,2.6816406 22,5.9780273 L22,16.0219726 C22,19.3183594 19.3183594,22 16.0219727,22 Z M5.9780273,2 C3.784668,2 2,3.784668 2,5.9780273 L2,16.0219726 C2,18.215332 3.784668,20 5.9780273,20 L16.0219726,20 C18.215332,20 20,18.215332 20,16.0219727 L20,5.9780273 C20,3.784668 18.215332,2 16.0219727,2 L5.9780273,2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,12 C2.6914062,12 0,9.3085937 0,6 C0,2.6914063 2.6914063,0 6,0 C9.3085937,0 12,2.6914063 12,6 C12,9.3085937 9.3085938,12 6,12 Z M6,2 C3.7944336,2 2,3.7944336 2,6 C2,8.2055664 3.7944336,10 6,10 C8.2055664,10 10,8.2055664 10,6 C10,3.7944336 8.2055664,2 6,2 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1313_",
    transform: "translate(16.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 1,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIg);
export default __webpack_public_path__ + "static/media/ic_ig.eec0f7d97446eb87aa111d658cca10ff.svg";
export { ForwardRef as ReactComponent };